<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button
        (click)="modalController.dismiss()"
        size="large"
        color="grey-500"
      >
        <ion-icon
          size="large"
          name="close"
          aria-label="close"
          slot="icon-only"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="ion-margin-horizontal half-centered">
    <ion-img
      src="assets/img/mable/mable-last-minute-logo.png"
      alt="mable last minute"
    ></ion-img>
  </div>
  <h1 class="header-news-22-bold">Introducing Mable Last Minute</h1>
  <p class="body-normal-16 ion-no-margin ion-margin-horizontal">
    A quick new way to find jobs required as soon as possible.
  </p>

  <ion-list
    lines="full"
    class="ion-margin-horizontal ion-color-grey-100"
  >
    <ion-item
      class="default body-normal-16"
      color="grey-100"
    >
      <ion-icon
        aria-hidden="true"
        name="clipboard"
        slot="start"
        color="orange-500"
      ></ion-icon>
      <ion-label class="ion-text-wrap"> Clients near you post jobs to start in the next 4-48 hours </ion-label>
    </ion-item>
    <ion-item
      class="default body-normal-16"
      color="grey-100"
    >
      <ion-icon
        aria-hidden="true"
        name="notifications"
        slot="start"
        color="orange-500"
      ></ion-icon>
      <ion-label class="ion-text-wrap"> If you are set as ‘Available’, you’ll be immediately notified </ion-label>
    </ion-item>
    <ion-item
      class="default body-normal-16"
      color="grey-100"
    >
      <ion-icon
        aria-hidden="true"
        name="fa-dollar-sign-solid"
        slot="start"
        color="orange-500"
      ></ion-icon>
      <ion-label class="ion-text-wrap"> If you’d like the job, make an offer with an hourly rate </ion-label>
    </ion-item>
    <ion-item
      class="default body-normal-16"
      color="grey-100"
    >
      <ion-icon
        aria-hidden="true"
        name="checkmark-circle"
        slot="start"
        color="orange-500"
      ></ion-icon>
      <ion-label class="ion-text-wrap"> Clients make a quick decision, at least 2 hours before start time </ion-label>
    </ion-item>
  </ion-list>
  <app-cancellation-policy buttonColor="purple-400"></app-cancellation-policy>
</ion-content>
